import { setUpLanguage } from "../dom";
import { getDeviceLanguage } from "../experience/utils";
const translations = require('../translations/translations.json');

export function initTranslations() {
    let language = getDeviceLanguage();
    if (language != 'fr' && language != 'es') language = 'en';
    for (let elementName in translations) {
        let element = <HTMLElement>document.querySelector('.' + elementName);
        element.innerHTML = translations[elementName][language];
    }
    setUpLanguage(language);
}